export enum StatusRefund {
    PendingApproval = 1,
    PendingPayment = 2,
    Paid = 3,
    Disapproved = 4,
    Canceled = 5,
    PartiallyApproved = 6
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/StatusRefund.ts